import { map, Observable, debounceTime, of, catchError } from "rxjs";
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from "@angular/forms";
import { ExistenceChecker } from "../interfaces/existence-checker.interface";

export function existsValidator<T1, T2 = any>(existenceCheckerService: ExistenceChecker<T1,T2>, currentId?: T2): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    if (!control.value) {
      return of(null); 
    }
    return existenceCheckerService.exists(control.value, currentId).pipe(         
      map(exists => (exists ? { exists: true } : null)),
      catchError(() => of(null))
    );
  };
}